import * as fromDatatype from '../datatype-library/index';

export interface bl_b2b_payment_request_stmt_to_einvoice_hdr_matching_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    payment_request_stmt_line_guid: fromDatatype.GuidDataFieldInterface;
    einvoice_email_ocr_hdr_guid: fromDatatype.GuidDataFieldInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    amount_contra: fromDatatype.NumericDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;  
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_b2b_payment_request_stmt_to_einvoice_hdr_matching_link_RowClass implements bl_b2b_payment_request_stmt_to_einvoice_hdr_matching_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    payment_request_stmt_line_guid: fromDatatype.GuidDataFieldInterface;
    einvoice_email_ocr_hdr_guid: fromDatatype.GuidDataFieldInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    amount_contra: fromDatatype.NumericDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;  
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
